<template>
  <div :id="componentId" class="spm6-news" :style="{ backgroundColor: bgColor }">
    <div class="spm6-news-list">
      <div
        v-for="(item, idx) in list"
        :key="item.articleCode || idx"
        class="spm6-news-card"
        @click="goTo(item)"
      >
        <img class="spm6-news-image" referrerpolicy="no-referrer" :src="item.imageUrl" />
        <div class="spm6-news-info">
          <span class="spm6-news-title">{{ item.title }}</span>
          <div class="spm6-news-meta">
            <span class="spm6-news-source">{{ item.source }}</span>
            <span class="spm6-news-time">&nbsp;|&nbsp;{{ formatTime(item.publishTime) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileNewsSection',
  props: {
    componentId: {
      type: String,
      default: 'sp_six_module_3'
    }
  },
  data() {
    return {
      bgColor: 'rgba(230, 236, 247, 1)',
      list: [
        { articleCode: '1', newsCode: '19299351', imageUrl: require('../../../special/SpecialSix/assets/img/FigmaDDSSlicePNG13f054723e412853ac73aa58a5029d29.png'), title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行', source: '中国品牌', publishTime: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(), url: '' },
        { articleCode: '2', newsCode: '19299352', imageUrl: require('../../../special/SpecialSix/assets/img/FigmaDDSSlicePNG13f054723e412853ac73aa58a5029d29.png'), title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行', source: '中国品牌', publishTime: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(), url: '' },
        { articleCode: '3', newsCode: '19299353', imageUrl: require('../../../special/SpecialSix/assets/img/FigmaDDSSlicePNG13f054723e412853ac73aa58a5029d29.png'), title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行', source: '中国品牌', publishTime: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(), url: '' },
        { articleCode: '4', newsCode: '19299354', imageUrl: require('../../../special/SpecialSix/assets/img/FigmaDDSSlicePNG13f054723e412853ac73aa58a5029d29.png'), title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行', source: '中国品牌', publishTime: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(), url: '' },
        { articleCode: '5', newsCode: '19299355', imageUrl: require('../../../special/SpecialSix/assets/img/FigmaDDSSlicePNG13f054723e412853ac73aa58a5029d29.png'), title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行', source: '中国品牌', publishTime: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(), url: '' },
        { articleCode: '6', newsCode: '19299356', imageUrl: require('../../../special/SpecialSix/assets/img/FigmaDDSSlicePNG13f054723e412853ac73aa58a5029d29.png'), title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行', source: '中国品牌', publishTime: '2026-07-09 00:00:00', url: '' }
      ]
    }
  },
  methods: {
    formatTime(publishTime) {
      if (!publishTime) return ''
      const now = Date.now()
      let parseValue = publishTime
      if (typeof publishTime === 'string' && publishTime.indexOf(' ') > -1 && publishTime.indexOf('T') === -1) {
        parseValue = publishTime.replace(' ', 'T')
      }
      const time = new Date(parseValue).getTime()
      if (isNaN(time)) return publishTime
      const diffMinutes = Math.floor((now - time) / 1000 / 60)
      if (diffMinutes < 1) return '刚刚'
      if (diffMinutes < 60) return `${diffMinutes}分钟前`
      const diffHours = Math.floor(diffMinutes / 60)
      if (diffHours < 24) return `${diffHours}小时前`
      const diffDays = Math.floor(diffHours / 24)
      return `${diffDays}天前`
    },
    goTo(item) {
      if (!item) return
      // 优先使用 newsCode 跳转到详情页
      if (item.articleCode) {
        this.$router.push(`/detail?newsCode=${item.articleCode}`)
        return
      }
      // 否则使用 url
      if (item.url) {
        window.open(item.url, '_blank')
      }
    }
  }
}
</script>

<style scoped>
.spm6-news {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.spm6-news-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.spm6-news-card {
  display: flex;
  gap: 10px;
  background: #fff;
  border-radius: 8px;
  padding: 8px;
  cursor: pointer;
}

.spm6-news-image {
  width: 100px;
  height: 72px;
  flex-shrink: 0;
  border-radius: 4px;
  object-fit: cover;
}

.spm6-news-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
}

.spm6-news-title {
  font-size: 14px;
  color: #333;
  line-height: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.spm6-news-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

.spm6-news-source,
.spm6-news-time {
  font-size: 11px;
  color: #999;
}

.spm6-news-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
</style>
